/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ReactComponent as PlusRegularIcon } from "assets/images/icons/common/plus-regular-brand.svg";


const AddImageButton = (props) => {
    const setOpen = props?.setOpen;

    const openDialog = () => {
        if (setOpen) {
            setOpen(true);
        }
    };

    return (
        <div 
            className="card-add-image-button"
            onClick={openDialog}
        >
            <PlusRegularIcon />
            <div className="card-add-image-button-text">Select Image</div>
        </div>
    );
};

AddImageButton.displayName = "AddImageButton";
export { AddImageButton };
